import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const Enquiry = () => {
  const [formStatus, setFormStatus] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "75cb7c6e-236d-42db-a2e9-5a3f0bf94d34");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setFormStatus("success");
      setSubmitted(true);  // Mark the form as successfully submitted
      setTimeout(() => {
        event.target.reset();  // Reset form after a slight delay
        setSubmitted(false);  // Reset the submitted status for potential future submissions
      }, 3000);  // Give user a few seconds to read the success message
    } else {
      setFormStatus("error");
      console.log("Error", data);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Enquiry</title>
      </Helmet>


      <div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>Enquiry</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

      <section className="news-details-section fix section-padding pt-0 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="de-item-list mb30 pt-5">
                  <h3 className="text-center darkcolor">Do You Have Any Query?</h3>
                  {!submitted ? (
                    <form
                      onSubmit={onSubmit}
                      name="contactForm"
                      id="contact_form"
                      className="form-border pb-0 enquiry-form"
                      method="post"
                    >
                      <input type="hidden" />
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="name" className="small fs-5">Your Full Name </label>
                            <input
                              name="name"
                              id="name"
                              className="form-control form-control-lg rounded-0"
                              placeholder="Your Full Name"
                              required
                              pattern="[A-Za-z\s]+"
                              title="Name must contain only letters"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="email" className="small fs-5">Your Email</label>
                            <input
                              type="email"
                              name="email"
                              id="email"
                              className="form-control form-control-lg rounded-0"
                              placeholder="Your Email"
                              required
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                              title="Please enter a valid email address"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="phone" className="small fs-5">Your Phone </label>
                            <input
                              type="tel"
                              name="phone"
                              id="phone"
                              className="form-control form-control-lg rounded-0"
                              placeholder="Your Phone"
                              required
                              pattern="[0-9]{10}"
                              title="Phone number must be of 10 digits"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group position-relative">
                            <label htmlFor="subject" className="small fs-5">Subject </label>
                            <input
                              name="subject"
                              id="subject"
                              className="form-control form-control-lg rounded-0"
                              placeholder="Subject"
                              required
                            />
                          </div>
                        </div>

                        <div className="form-group position-relative col-12">
                          <textarea
                            name="message"
                            id="message"
                            className="form-control form-control-lg rounded-0"
                            placeholder="Your Message"
                            required
                          />
                        </div>
                        <div className="g-recaptcha" data-sitekey="copy-your-site-key-here"></div>
                        <div id="submit" className="mt20 text-center pb-3 px-4">
                          <input
                            type="submit"
                            id="send_message"
                            value="Submit"
                            className="btn-main mt-2 py-3 px-3 text-center fw-bold fs-3  bg-tn"
                          />
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className="success-message">
                      <h3>Your details have been submitted successfully!</h3>
                      <p>Thank you for your enquiry. We will get back to you shortly.</p>
                    </div>
                  )}

                  {/* Error Message */}
                  {formStatus === "error" && (
                    <div id="error_message" className="error">
                      Sorry, something went wrong. Try again later.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Enquiry;
